"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportEditorEditApi = reportEditorEditApi;
exports.reportEditorEditRecordApi = reportEditorEditRecordApi;
exports.reportEditorListApi = reportEditorListApi;
exports.reportEditorLockApi = reportEditorLockApi;
exports.reportEditorLockExistApi = reportEditorLockExistApi;
exports.reportEditorUnlockApi = reportEditorUnlockApi;
var _core = require("../../../core/core.service");
var _app = _interopRequireDefault(require("../../../../configs/app.config"));
var _dashboard = require("../../../../constants/endpoints/dashboard");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @flow

var api = new _core.APICore();

/**
 * editor report edit
 * @param payload
 * @returns api response
 * @description this function used to editor report edit.
 */
function reportEditorEditApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ReportService.reportEditor.editReport), params);
}

/**
 * editor report edit
 * @param payload
 * @returns api response
 * @description this function used to editor report edit.
 */
function reportEditorListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ReportService.reportEditor.list), params);
}

/**
 * editor report edit exist
 * @param payload
 * @returns api response
 * @description this function used to editor report edit.
 */
function reportEditorLockExistApi(params) {
  var headersConfig = JSON.parse(sessionStorage.getItem("headersConfigReport")) || {
    headers: {
      referrer: window.location.origin + "/platform/report-update",
      originReferer: window.location.origin + "/platform"
    }
  };
  return api.get("".concat(_app.default.baseUrl + _dashboard.ReportService.reportEditor.editorLockExist), params, headersConfig);
}

/**
 * editor report edit
 * @param payload
 * @returns api response
 * @description this function used to editor report edit.
 */
function reportEditorLockApi(params) {
  var headersConfig = JSON.parse(sessionStorage.getItem("headersConfigReport")) || {
    headers: {
      referrer: window.location.origin + "/platform/report-edit",
      originReferer: window.location.origin + "/platform"
    }
  };
  return api.update("".concat(_app.default.baseUrl + _dashboard.ReportService.reportEditor.editorLock), params, headersConfig);
}

/**
 * editor report edit
 * @param payload
 * @returns api response
 * @description this function used to editor report edit.
 */
function reportEditorUnlockApi(params) {
  var headersConfig = JSON.parse(sessionStorage.getItem("headersConfigReport")) || {
    headers: {
      referrer: window.location.origin + "/platform/report-edit",
      originReferer: window.location.origin + "/platform"
    }
  };
  return api.update("".concat(_app.default.baseUrl + _dashboard.ReportService.reportEditor.editorUnlock), params, headersConfig);
}

/**
 * controller report clone
 * @param payload
 * @returns api response
 * @description this function used to controller report clone.
 */
function reportEditorEditRecordApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ReportService.reportEditor.editRecord), params);
}